import { GroupBase, StylesConfig } from 'react-select';

export function setCustomStyles<
  T,
  IsMulti extends boolean,
  Group extends GroupBase<T>
  >(): StylesConfig<T, IsMulti, Group> {
  return {
    valueContainer: (provided, state) => {
      return {
        ...provided,
        pointerEvents: state.isDisabled ? 'auto' : provided.pointerEvents,
      };
    },
  };
}
